module.exports = __webpack_public_path__ + "static/img/77021A_2_3_R_20180428_n_fit.051df6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77021A_2_3_R_20180428_n_fit.png
// module id = rM4z
// module chunks = 0